"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e-137":{"id":"e-137","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-61","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-138"}},"mediaQueries":["main","medium"],"target":{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1710449099843},"e-138":{"id":"e-138","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-62","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-137"}},"mediaQueries":["main","medium"],"target":{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d8be518a-f1fd-313e-be85-ba0c5ffa7965","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1710449099844}},"actionLists":{"a-61":{"id":"a-61","title":"Hover-Search Modal Row","actionItemGroups":[{"actionItems":[{"id":"a-61-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".search-modal---result-hover-icon","selectorGuids":["9f8d9d19-e577-4d4f-62de-792215333ab1"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1710449104207},"a-62":{"id":"a-62","title":"Hover - Search Modal OffHover","actionItemGroups":[{"actionItems":[{"id":"a-62-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".search-modal---result-hover-icon","selectorGuids":["9f8d9d19-e577-4d4f-62de-792215333ab1"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1710449165554}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SearchModalResultCommunityAndMarket({
  as: _Component = _Builtin.Link,

  linkProps = {
    href: "#",
  },

  line1Slot,
  line2Slot,
  showImage = false,
  imageSlot,
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component
      className="search-modal-result-link-com"
      data-w-id="d8be518a-f1fd-313e-be85-ba0c5ffa7965"
      button={false}
      block="inline"
      options={linkProps}
    >
      <_Builtin.Block className="div-block-97" tag="div">
        {showImage ? (
          <_Builtin.Block className="search-modal-image-thumb" tag="div">
            {imageSlot ?? (
              <_Builtin.Image
                className="search-modal---image---slot-class"
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd33250bf2f46d247e66c9_Artizan-Default%20-%20high.jpeg"
              />
            )}
          </_Builtin.Block>
        ) : null}
        <_Builtin.Block tag="div">
          <_Builtin.Block className="search-modal-result-line-1" tag="div">
            {line1Slot ?? (
              <_Builtin.HtmlEmbed value="California%20%26gt%3B%20%3Cmark%3ESan%3C%2Fmark%3E%20%3Cmark%3EFrancisco%3C%2Fmark%3E%20Bay%20Area" />
            )}
          </_Builtin.Block>
          <_Builtin.Block className="div-block-104" tag="div">
            {line2Slot ?? (
              <_Builtin.HtmlEmbed value="California%20%26gt%3B%20%3Cmark%3ESan%3C%2Fmark%3E%20%3Cmark%3EFrancisco%3C%2Fmark%3E%20Bay%20Area" />
            )}
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className="search-modal---result-hover-icon" tag="div">
          <_Builtin.HtmlEmbed
            className="html-embed-6"
            value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M304%2024c0%2013.3%2010.7%2024%2024%2024H430.1L207%20271c-9.4%209.4-9.4%2024.6%200%2033.9s24.6%209.4%2033.9%200l223-223V184c0%2013.3%2010.7%2024%2024%2024s24-10.7%2024-24V24c0-13.3-10.7-24-24-24H328c-13.3%200-24%2010.7-24%2024zM72%2032C32.2%2032%200%2064.2%200%20104V440c0%2039.8%2032.2%2072%2072%2072H408c39.8%200%2072-32.2%2072-72V312c0-13.3-10.7-24-24-24s-24%2010.7-24%2024V440c0%2013.3-10.7%2024-24%2024H72c-13.3%200-24-10.7-24-24V104c0-13.3%2010.7-24%2024-24H200c13.3%200%2024-10.7%2024-24s-10.7-24-24-24H72z%22%2F%3E%3C%2Fsvg%3E"
          />
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
